export const uploadFileToAWSS3 = async (presignedUrl, { fileContent, contentType }) => {
  try {
    const headers = { 'Content-Type': contentType, 'x-amz-acl': 'public-read' };
    return await fetch(presignedUrl, { method: 'PUT', headers, body: fileContent });
  } catch (e) {
    return null;
  }
};

export const uploadFileToS3WithProgress = (presignedUrl, { fileSize, fileContent, contentType }, progressCallback) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve(xhr);
        } else {
          reject(xhr);
        }
      }
    };

    if (progressCallback) {
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          var percentComplete = (e.loaded / fileSize) * 100;
          progressCallback(percentComplete);
        }
      };
    }

    xhr.open('PUT', presignedUrl);
    xhr.setRequestHeader('Content-Type', contentType);
    xhr.setRequestHeader('x-amz-acl', 'public-read');
    xhr.send(fileContent);
  });
};
